import { useEffect, useRef, useState } from 'react';

import realShifts from '../../images/real-shifts.jpg';
import realShiftsIconFirst from '../../images/real-shifts-icon-first.png';
import realShiftsIconSecond from '../../images/real-shifts-icon-second.png';
import realShiftsIconThird from '../../images/real-shifts-icon-third.png';
import bringUniverseFirst from '../../images/bring-universe-first.jpg';
import bringUniverseSecond from '../../images/bring-universe-second.jpg';
import cardFirst from '../../images/card-first.jpg';
import cardSecond from '../../images/card-second.jpg';
import cardThird from '../../images/card-third.jpg';
import cardFourth from '../../images/card-fourth.jpg';
import cardFifth from '../../images/card-fifth.jpg';
import cardSixth from '../../images/card-sixth.png';
import cardSeventh from '../../images/card-seventh.png';
import cardEighth from '../../images/card-eighth.png';
import cardNinth from '../../images/card-ninth.png';
import cardTenth from '../../images/card-tenth.png';
import reviewsFirst from '../../images/reviews-first.jpg';
import reviewsSecond from '../../images/reviews-second.jpg';
import reviewsThird from '../../images/reviews-third.jpg';
import videoPoster from '../../images/video-poster.png';
import authorPhoto from '../../images/author-photo.png';
import authorName from '../../images/author-name.svg';
import connectFirst from '../../images/connect-first.png';
import connectSecond from '../../images/connect-second.png';
import video from '../../video/video.mp4';

export const En = (props) => {
    const [isLangMenuVisible, setLangMenuVisibility] = useState(false);
    const [isPopupVisible, setPopupVisibility] = useState(false);
    const [isReviewNumber, setReviewNumber] = useState(1);
    const realShiftsRef = useRef(null);
    const ritualsRef = useRef(null);
    const cardsRef = useRef(null);
    const reviewsRef = useRef(null);
    const howItWorksRef = useRef(null);
    const authorRef = useRef(null);
    const connectRef = useRef(null);
    const faqRef = useRef(null);
    const contentRef = useRef(null);

    const toggleLangMenuVisible = () => setLangMenuVisibility(!isLangMenuVisible);

    const togglePopupVisible = () => setPopupVisibility(!isPopupVisible);

    const scrollToRealShifts = () => {
        realShiftsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToRituals = () => {
        ritualsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToCards = () => {
        cardsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToReviews = () => {
        reviewsRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToHowItWorks = () => {
        howItWorksRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToAuthor = () => {
        authorRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToConnect = () => {
        connectRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    const scrollToFaq = () => {
        faqRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        let position = 0;
        const speed = 0.4;
        let animationFrameId;

        const animate = () => {
            if (!contentRef.current) return;

            position += speed;
            const contentWidth = contentRef.current.scrollWidth / 2;

            if (position >= contentWidth) {
                position = 0;
            }

            contentRef.current.style.transform = `translateX(${-position}px)`;
            animationFrameId = requestAnimationFrame(animate);
        };

        animate();

        return () => cancelAnimationFrame(animationFrameId);
    }, []);

    const cards = (
        <>
            <div className="card__container-first">
                <div className="card__image-info-container-first">
                    <div className="card__image-container">
                        <img className="card__image-small" src={cardFirst} alt="Card" />
                    </div>

                    <div className="bring-universe__text-container">
                        <p className="text-subtitle-bold">Happy destiny</p>
                        <p className="text">Wherever your heart resides, there you will discover your true treasure.</p>
                    </div>
                </div>

                <div className="card__image-container card__image-container_type_margin-left">
                    <img className="card__image-small" src={cardSecond} alt="Card" />
                </div>
            </div>

            <div className="card__container-second">
                <div className="card__image-container-big">
                    <img className="card__image-big" src={cardThird} alt="Card" />
                </div>

                <div className="bring-universe__text-container">
                    <p className="text-subtitle-bold card__text">Power of the Elements of Nature</p>
                    <p className="text card__text">The star symbolizes the five elements: the four forces of nature and the Soul — together they form the Microcosm.</p>
                </div>
            </div>

            <div className="card__container-third">
                <div className="card__image-info-container-second">
                    <div className="card__image-container">
                        <img className="card__image-small" src={cardFourth} alt="Card" />
                    </div>

                    <div className="bring-universe__text-container">
                        <p className="text-subtitle-bold">Wealth</p>
                        <p className="text">The Heart is the central element, the source of energy and inner power.</p>
                    </div>
                </div>

                <div className="card__image-info-container-first card__image-info-container-first_type_margin">
                    <div className="card__image-container">
                        <img className="card__image-small" src={cardFifth} alt="Card" />
                    </div>

                    <div className="bring-universe__text-container">
                        <p className="text-subtitle-bold">Gift of the Universe</p>
                        <p className="text">Each card of the ‘Spirits of the Universe’ deck is handcrafted on canvas with immense love.</p>
                    </div>
                </div>
            </div>

            <div className="card__container-second card__container-second_type_margin">
                <div className="card__image-container-big">
                    <img className="card__image-big" src={cardSixth} alt="Card" />
                </div>
            </div>

            <div className="card__container-fourth">
                <div className="card__image-info-container-second card__image-info-container-second_type_reverse">
                    <div className="card__image-container">
                        <img className="card__image-small" src={cardSeventh} alt="Card" />
                    </div>

                    <div className="bring-universe__text-container">
                        <p className="text-subtitle-bold">Dragon</p>
                        <p className="text">Dragon kindles a sacred flame of transformation within your soul, awakening fierce inner strength and guiding your spirit with unwavering perseverance each day.</p>
                    </div>
                </div>
            </div>

            <div className="card__container-second">
                <div className="card__image-container-big">
                    <img className="card__image-big" src={cardEighth} alt="Card" />
                </div>

                <div className="bring-universe__text-container">
                    <p className="text-subtitle-bold card__text">Star</p>
                    <p className="text card__text">Your radiance sets your heart free and the Universe makes your dreams come true.</p>
                </div>
            </div>

            <div className="card__container-third card__container-third_type_width">
                <div className="card__image-info-container-second">
                    <div className="card__image-container">
                        <img className="card__image-small" src={cardNinth} alt="Card" />
                    </div>

                    <div className="bring-universe__text-container">
                        <p className="text-subtitle-bold">Well-Being</p>
                        <p className="text">To embrace the energy of Well-Being is to unlock the very laws of the Universe, where abundance flows in harmony with your highest path.</p>
                    </div>
                </div>

                <div className="card__image-info-container-first card__image-info-container-first_type_margin-second">
                    <div className="card__image-container">
                        <img className="card__image-small" src={cardTenth} alt="Card" />
                    </div>
                </div>
            </div>
        </>
    );

    function openRu() {
        props.history.push('/ru');
    }

    function openCn() {
        props.history.push('/cn');
    }

    function openAr() {
        props.history.push('/ar');
    }

    const nextReview = (number) => {
        setReviewNumber(() => {
            let next = isReviewNumber + number;
            if (next < 1) next = 1;
            if (next > 3) next = 3;
            return next;
        });
    }

    const renderReview = () => {
        if (isReviewNumber === 1)
            return (
                <div className="reviews__card">
                    <img className="reviews__card-image" src={reviewsFirst} alt="Layla" />

                    <div className="reviews__card-text-container">
                        <a href="https://www.instagram.com/natalivellee" className="text card__text reviews__link">@natalivellee</a>
                        <p className="text-subtitle-bold card__text">Natali, UAE, Dubai</p>
                        <p className="text card__text">The artwork alone is healing. The messages gave me hope when I needed it most.</p>
                    </div>
                </div>
            );

        if (isReviewNumber === 2)
            return (
                <div className="reviews__card">
                    <img className="reviews__card-image" src={reviewsSecond} alt="Lena" />

                    <div className="reviews__card-text-container">
                        <a href="https://www.instagram.com/ksenia_moskvina" className="text card__text reviews__link">@ksenia_moskvina</a>
                        <p className="text-subtitle-bold card__text">Ksenia, UAE, Dubai</p>
                        <p className="text card__text">I drew ‘Gratitude’ three mornings in a row — and everything shifted in my life.</p>
                    </div>
                </div>
            );

        if (isReviewNumber === 3)
            return (
                <div className="reviews__card">
                    <img className="reviews__card-image" src={reviewsThird} alt="Anna" />

                    <div className="reviews__card-text-container">
                        <a href="https://www.instagram.com/lana8.art" className="text card__text reviews__link">@lana8.art</a>
                        <p className="text-subtitle-bold card__text">Svetlana, Switzerland</p>
                        <p className="text card__text">I use one card every day with my clients in healing sessions. They're pure magic.</p>
                    </div>
                </div>
            );
    }

    return (
        <>
            <header className="header">
                <div className="header__logo-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="50" viewBox="0 0 58 50" fill="none">
                        <path d="M29.0548 6.02333C33.1955 1.91079 39.3083 -1.06841 45.3538 0.364519C51.3308 1.75708 55.8019 5.73024 57.3537 11.3441C58.9899 16.9858 57.4837 23.456 53.2415 27.6421L53.2369 27.647C47.459 33.1457 41.6741 38.6376 35.8822 44.1225C33.8125 46.0826 31.7418 48.0417 29.6703 50C31.7059 48.0064 33.7425 46.0135 35.78 44.0216C40.0562 39.8411 44.3365 35.6645 48.6206 31.4917L52.901 27.325C56.9767 23.2092 58.3634 16.9512 56.7432 11.5079C55.2055 6.08906 50.8453 2.34702 45.1874 1.0586C39.343 -0.304602 33.3841 2.66357 29.3305 6.8187L29.0576 7.09043L28.7841 6.81945C28.7483 6.78401 28.7125 6.74872 28.6768 6.71367C24.6099 2.61269 18.663 -0.290777 12.8496 1.05916C7.18527 2.33049 2.79006 6.04379 1.25689 11.4685C-0.393626 16.979 1.10447 23.2763 5.21332 27.4423L9.5266 31.5877C13.8449 35.741 18.1592 39.8983 22.4696 44.0594C24.5199 46.0386 26.5693 48.0189 28.6178 50C26.5337 48.0546 24.4505 46.1082 22.3681 44.161C16.531 38.7027 10.7009 33.2372 4.87777 27.7649L4.87123 27.7585C0.602464 23.5311 -1.02375 17.0167 0.644684 11.3042C2.19132 5.68305 6.70596 1.73571 12.6834 0.364145C18.7481 -1.06662 24.8984 1.9093 29.0548 6.02333Z" fill="white"/>
                        <path d="M24.6936 16.0711C25.7321 16.0711 26.8413 17.1025 26.4164 17.315C26.2951 17.3756 26.0586 17.4362 25.9016 17.4725C25.8118 17.4933 25.7473 17.5733 25.7485 17.6654L25.9354 32.6268C25.9367 32.7316 26.022 32.8158 26.1268 32.8158H34.6474C35.7677 32.8158 36.3111 30.9291 36.5315 29.8387C36.571 29.6435 36.8512 29.6168 36.914 29.8058C37.2327 30.7665 37.7122 32.4629 37.5187 33.4856C37.5018 33.5749 37.481 33.6641 37.4576 33.7515C37.2742 34.4372 36.5958 34.8251 35.8858 34.8251H25.3636C24.3064 34.8251 23.4494 33.9683 23.4494 32.9114V16.4004C23.4494 16.318 23.5021 16.2454 23.5816 16.2239C23.7891 16.168 24.2172 16.0711 24.6936 16.0711Z" fill="white"/>
                        <path d="M19.3341 21.238C19.3341 21.238 20.0996 25.1302 19.3341 27.5532C18.7597 29.3711 17.3241 30.8064 16.2712 30.0409C15.2184 29.2754 15.5114 27.6488 17.0369 26.2136C18.5623 24.7783 19.3341 21.238 19.3341 21.238Z" fill="white"/>
                        <path d="M37.7062 19.7749C37.7215 19.7835 41.1709 21.718 42.5184 23.8658C43.5317 25.4809 43.6955 27.5041 42.4302 27.8101C41.1648 28.1162 40.1151 26.8392 40.0096 24.7477C39.9042 22.6597 37.7137 19.7848 37.7062 19.7749Z" fill="white"/>
                        <path d="M24.4616 9.8077C24.477 9.81095 28.347 10.6335 30.2723 12.2846C31.7197 13.526 32.4771 15.4092 31.3598 16.0772C30.2425 16.7452 28.8608 15.8377 28.1386 13.8718C27.4181 11.9106 24.4755 9.81757 24.4616 9.8077Z" fill="white"/>
                    </svg>
                </div>

                <div className="header__menu">
                    <a onClick={scrollToRituals} className="header__link">Rituals</a>
                    <a onClick={scrollToCards} className="header__link">Cards</a>
                    <a onClick={scrollToReviews} className="header__link">Reviews</a>
                    <a onClick={scrollToHowItWorks} className="header__link">How it Works</a>
                    <a onClick={scrollToAuthor} className="header__link">Author</a>
                    <a onClick={scrollToFaq} className="header__link">FAQ</a>
                </div>

                <div className="header__button-container">
                    <div className="header__lang-content">
                        <button className="header__lang-button" onClick={() => toggleLangMenuVisible()}>
                            <span>EN</span>

                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18.5761 8.57617C18.8104 8.34186 19.1895 8.34186 19.4238 8.57617C19.6581 8.81049 19.6581 9.18951 19.4238 9.42383L12.4238 16.4238C12.3113 16.5364 12.1591 16.5996 12 16.5996C11.8408 16.5996 11.6886 16.5364 11.5761 16.4238L4.57613 9.42383C4.34181 9.18951 4.34181 8.81049 4.57613 8.57617C4.81044 8.34186 5.18947 8.34186 5.42378 8.57617L12 15.1523L18.5761 8.57617Z" fill="white"/>
                            </svg>
                        </button>

                        <div className={`header__lang-container ${isLangMenuVisible ? 'header__lang-container_type_visible' : ''}`}>
                            <button className="header__lang-button header__lang-button_type_color-choosen" onClick={() => toggleLangMenuVisible()}>EN</button>
                            <button className="header__lang-button header__lang-button_type_color" onClick={openRu}>RU</button>
                            <button className="header__lang-button header__lang-button_type_color" onClick={openCn}>CN</button>
                            <button className="header__lang-button header__lang-button_type_color" onClick={openAr}>AR</button>
                        </div>
                    </div>

                    <button className="header__button header__button_type_display-none" onClick={scrollToConnect}>Get the Deck</button>
                </div>
            </header>

            <section className="main-screen">
                <div className="main-screen__content-container">
                    <div className="main-screen__content">
                        <div className="main-screen__heading-container">
                            <h1 className="main-screen__title">Unlock <span className="main-screen__title_type_pp-pangaia">the Secrets</span> of Universe</h1>

                            <p className="text-subtitle-bold main-screen__text">A soul deck to help you align with your heart, awaken your spirit, and transform your life</p>
                        </div>

                        <div className="main-screen__arrow-container">
                            <a onClick={scrollToRealShifts}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="71" viewBox="0 0 13 71" fill="none">
                                    <path d="M12.7446 63.9626C13.0851 64.3031 13.0851 64.8551 12.7446 65.1957L7.19567 70.7446C6.85512 71.0851 6.30312 71.0851 5.96258 70.7446L0.413653 65.1957C0.0731077 64.8551 0.0731077 64.3031 0.413653 63.9626C0.754199 63.622 1.3062 63.622 1.64675 63.9626L5.7071 68.0229L5.7071 0.366272L7.45114 0.366272L7.45115 68.0229L11.5115 63.9626C11.852 63.622 12.404 63.622 12.7446 63.9626Z" fill="white"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="real-shifts" ref={realShiftsRef}>
                <div className="real-shifts__heading-container">
                    <h2 className="real-shifts__title">Real <span className="main-screen__title_type_pp-pangaia">Shifts.</span> Real Alignment.</h2>

                    <p className="real-shifts__text text-subtitle-bold">This deck is an energetic tool that gently rewires your reality. Here’s what starts to change</p>
                </div>

                <div className="real-shifts__content-container">
                    <div className="real-shifts__image-container">
                        <img className="real-shifts__image" src={realShifts} alt="Real Shifts. Real Alignment." />
                    </div>

                    <div className="real-shifts__container">
                        <div className="real-shifts__item-container">
                            <div className="real-shifts__icon-container">
                                <img className="real-shifts__icon" src={realShiftsIconFirst} alt="Icon" />
                            </div>

                            <div className="real-shifts__item-text-container">
                                <p className="text-subtitle-bold real-shifts__item-text">You feel more connected</p>

                                <p className="text real-shifts__item-text">To yourself, your purpose, and higher guidance</p>
                            </div>
                        </div>

                        <div className="real-shifts__item-container">
                            <div className="real-shifts__icon-container">
                                <img className="real-shifts__icon" src={realShiftsIconSecond} alt="Icon" />
                            </div>

                            <div className="real-shifts__item-text-container">
                                <p className="text-subtitle-bold real-shifts__item-text">You attract what you need</p>

                                <p className="text real-shifts__item-text">Health, abundance, clarity, aligned relationships</p>
                            </div>
                        </div>

                        <div className="real-shifts__item-container">
                            <div className="real-shifts__icon-container">
                                <img className="real-shifts__icon" src={realShiftsIconThird} alt="Icon" />
                            </div>

                            <div className="real-shifts__item-text-container">
                                <p className="text-subtitle-bold real-shifts__item-text">You feel protected</p>

                                <p className="text real-shifts__item-text">Сards with Mandalas which healing heart and increase power</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="real-shifts__button-container">
                    <button className="header__button real-shifts__button" onClick={scrollToConnect}>Get the Deck</button>
                </div>
            </section>

            <section className="bring-universe" ref={ritualsRef}>
                <div className="bring-universe__heading-container">
                    <div className="bring-universe__heading-text-container">
                        <h2 className="bring-universe__title">Bring <span className="main-screen__title_type_pp-pangaia">Universe</span> Souls into Your Daily Life</h2>
                        <p className="text-subtitle-bold">Practical Rituals for Real Results</p>
                    </div>

                    <div className="bring-universe__images-container">
                        <div className="bring-universe__image-container">
                            <img className="bring-universe__image" src={bringUniverseFirst} alt="Bring Universe Souls into Your Daily Life" />
                        </div>

                        <div className="bring-universe__image-info-container">
                            <div className="bring-universe__image-container">
                                <img className="bring-universe__image" src={bringUniverseSecond} alt="Bring Universe Souls into Your Daily Life" />
                            </div>

                            <div>
                                <p className="bring-universe__info-text">Feel it.</p>
                                <p className="bring-universe__info-text">Repeat it.</p>
                                <p className="bring-universe__info-text">Make it happens.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bring-universe__info-container">
                    <div className="bring-universe__container">
                        <div className="bring-universe__text-container">
                            <p className="text-subtitle-bold">Healing Practice</p>
                            <p className="text">Speak the card’s message aloud 3–5 times, feeling every word. Let your body absorb its vibration.</p>
                        </div>

                        <div className="bring-universe__text-container">
                            <p className="text-subtitle-bold">Manifestation Companion</p>
                            <p className="text">Place the card under your pillow, on your altar, or desk. Let its energy influence your reality.</p>
                        </div>
                    </div>

                    <div className="bring-universe__text-container">
                        <p className="text-subtitle-bold">Morning Intention Ritual</p>
                        <p className="text">Pull a card to start the day with clarity, love, or protection.</p>
                    </div>
                </div>
            </section>

            <section className="card" ref={cardsRef}>
                <div className="card__heading-container card__heading-container_type_padding">
                    <h2 className="bring-universe__title">What’s <span className="main-screen__title_type_pp-pangaia">inside</span></h2>
                    <p className="text-subtitle-bold card__text">Each card is an energetic painting — created in sacred meditation — carrying codes of love, healing, and awakening</p>
                </div>

                <div className="card__content-container">
                    <div className="card__scroll-container" id="marquee">
                        <div className="card__scroll-content" ref={contentRef}>
                            {cards}
                            {cards}
                        </div>
                    </div>

                    <button className="header__button real-shifts__button" onClick={scrollToConnect}>Explore All 24 Cards</button>
                </div>
            </section>

            <section className="reviews" ref={reviewsRef}>
                <h2 className="real-shifts__title">Stories from <span className="main-screen__title_type_pp-pangaia">Open Hearts</span></h2>

                <div className="reviews__content-container">
                    <div className="reviews__card">
                        <img className="reviews__card-image" src={reviewsFirst} alt="Layla" />

                        <div className="reviews__card-text-container">
                            <a href="https://www.instagram.com/natalivellee" className="text card__text reviews__link">@natalivellee</a>
                            <p className="text-subtitle-bold card__text">Natali, UAE, Dubai</p>
                            <p className="text card__text">The artwork alone is healing. The messages gave me hope when I needed it most.</p>
                        </div>
                    </div>

                    <div className="reviews__card">
                        <img className="reviews__card-image" src={reviewsSecond} alt="Lena" />

                        <div className="reviews__card-text-container">
                            <a href="https://www.instagram.com/ksenia_moskvina" className="text card__text reviews__link">@ksenia_moskvina</a>
                            <p className="text-subtitle-bold card__text">Ksenia, UAE, Dubai</p>
                            <p className="text card__text">I drew ‘Gratitude’ three mornings in a row — and everything shifted in my life.</p>
                        </div>
                    </div>

                    <div className="reviews__card">
                        <img className="reviews__card-image" src={reviewsThird} alt="Anna" />

                        <div className="reviews__card-text-container">
                            <a href="https://www.instagram.com/lana8.art" className="text card__text reviews__link">@lana8.art</a>
                            <p className="text-subtitle-bold card__text">Lana, Switzerland</p>
                            <p className="text card__text">I use one card every day with my clients in healing sessions. They're pure magic.</p>
                        </div>
                    </div>
                </div>

                <div className="reviews__content-container-mobile">
                    <button className="reviews__slider-button reviews__slider-button_type_left" onClick={() => nextReview(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="inherit">
                            <path d="M30.8477 37.1523C31.3164 37.6209 31.3164 38.3789 30.8477 38.8476C30.3791 39.3162 29.6211 39.3162 29.1524 38.8476L15.1524 24.8476C14.9274 24.6225 14.8009 24.3182 14.8009 23.9999C14.8009 23.6816 14.9274 23.3773 15.1524 23.1523L29.1524 9.15225C29.6211 8.68362 30.3791 8.68362 30.8477 9.15225C31.3164 9.62088 31.3164 10.3789 30.8477 10.8476L17.6954 23.9999L30.8477 37.1523Z" fill="inherit"/>
                        </svg>
                    </button>

                    {renderReview()}

                    <button className="reviews__slider-button reviews__slider-button_type_right" onClick={() => nextReview(1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="inherit">
                            <path d="M17.1523 37.1523C16.6836 37.6209 16.6836 38.3789 17.1523 38.8476C17.6209 39.3162 18.3789 39.3162 18.8476 38.8476L32.8476 24.8476C33.0726 24.6225 33.1991 24.3182 33.1991 23.9999C33.1991 23.6816 33.0726 23.3773 32.8476 23.1523L18.8476 9.15225C18.3789 8.68362 17.6209 8.68362 17.1523 9.15225C16.6836 9.62088 16.6836 10.3789 17.1523 10.8476L30.3046 23.9999L17.1523 37.1523Z" fill="inherit"/>
                        </svg>
                    </button>
                </div>

                <button className="header__button real-shifts__button" onClick={scrollToConnect}>Create your own story</button>
            </section>

            <section className="video" ref={howItWorksRef}>
                <div className="card__heading-container">
                    <p className="text-subtitle-bold card__text">The Sacred Connection</p>
                    <h2 className="bring-universe__title card__text">"The greatest <span className="main-screen__title_type_pp-pangaia">journey</span> is the one from mind to <span className="main-screen__title_type_pp-pangaia">heart</span>"</h2>
                    <p className="text card__text">Every card in this deck contains a heart — the symbol of divine access. When spoken out loud with emotion, the messages become keys.</p>
                </div>

                <div className="video__video-container">
                    <video className="video__video" autoPlay muted loop poster={videoPoster} playsInline>
                        {/* <source src={showreel} type="video/mp4" /> */}
                    </video>

                    <button className="video__play-button" onClick={() => togglePopupVisible()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109 110" fill="none">
                            <path d="M75 54.8525L41 74.4824V35.2227L75 54.8525Z" fill="white"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M54.5 0.222656C84.5995 0.222656 109 24.6231 109 54.7227C109 84.8222 84.5995 109.223 54.5 109.223C24.4005 109.223 0 84.8222 0 54.7227C0 24.6231 24.4005 0.222656 54.5 0.222656ZM54.5 1.22266C24.9528 1.22266 1 25.1754 1 54.7227C1 84.2699 24.9528 108.223 54.5 108.223C84.0472 108.223 108 84.2699 108 54.7227C108 25.1754 84.0472 1.22266 54.5 1.22266Z" fill="white"/>
                        </svg>
                    </button>

                     <span className="text video__text">See how it use in action</span>
                </div>
            </section>

            <section className="author" ref={authorRef}>
                <div className="author__heading-container">
                    <h2 className="author__title author__text">Created in <span className="main-screen__title_type_pp-pangaia">Divine Flow</span></h2>
                    <p className="text-subtitle-bold author__text">I’m Natalia — a cosmic soul, energy healer, and intuitive artist.</p>
                </div>

                <div className="author__content-container">
                    <div className="author__image-container">
                        <img className="author__photo" src={authorPhoto} alt="Author" />
                        <img className="author__name" src={authorName} alt="Name" />
                    </div>

                    <div className="author__text-container">
                        <p className="text">This deck was born through deep meditations, universal downloads, and connection with the Great Creator, angels, and all five sacred elements of nature.</p>

                        <p className="text">Each card is a portal, painted by hand during energetic practice. The symbols, shapes, and colors are infused with intention — to support your healing, abundance, and awakening. This isn’t just art — it’s energy in form.</p>

                        <button className="header__button real-shifts__button author__button" onClick={() => window.open('https://www.instagram.com/leanca_happy', '_blank', 'noopener, noreferrer')}>Follow Natalia</button>
                    </div>
                </div>
            </section>

            <section className="connect" ref={connectRef}>
                <div className="connect__heading-container">
                    <h2 className="connect__title">Choose Your Way to Connect With the <span className="main-screen__title_type_pp-pangaia">Universe</span></h2>
                    <p className="text-subtitle-bold connect__text">Whether you prefer the sacred feel of a physical card in your hand or the convenience of always having your guidance in your pocket — we've got you covered.</p>
                </div>

                <div className="connect__container">
                    <div className="connect__card">
                        <p className="text-subtitle-bold">Download the App</p>

                        <div className="connect__card-container">
                            <img className="connect__image" src={connectFirst} alt="Download the App" />

                            <p className="text connect__text">Carry the energy of the cards with you wherever you go.  Pull a card daily. Set reminders. Speak your affirmations.</p>

                            <div className="connect__buttons-container">
                                <button className="header__button real-shifts__button">Apple Store</button>
                                <button className="header__button real-shifts__button">Play Market</button>
                            </div>
                        </div>
                    </div>

                    <div className="connect__card">
                        <p className="text-subtitle-bold">Buy the Deck</p>

                        <div className="connect__card-container">
                            <img className="connect__image" src={connectSecond} alt="Buy the Deck" />

                            <p className="text connect__text">Feel the textures, see the art in full, hold the energy. Each deck is printed with love, packaged with care, and blessed in ceremony.</p>

                            <div className="connect__buttons-container">
                                <button className="header__button connect__button">Amazon</button>
                                <button className="header__button connect__button">Noon</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="faq" ref={faqRef}>
                <h2 className="faq__title">Created in Divine Flow</h2>

                <div className="faq__accordion">
                    <details className="faq__details">
                        <summary className="faq__summary">Do I need experience to use the deck?<span className="faq__arrow"></span></summary>

                        <p className="text faq__text">Not at all. These cards are for beginners and masters alike. Just choose a card, speak its message, and feel the energy.</p>
                    </details>

                    <details className="faq__details">
                        <summary className="faq__summary">How are the cards created?<span className="faq__arrow"></span></summary>

                        <p className="text faq__text">Every image is painted by hand during a meditation and energy session. The messages are channeled through spiritual connection.</p>
                    </details>

                    <details className="faq__details">
                        <summary className="faq__summary">How do I cleanse the cards?<span className="faq__arrow"></span></summary>

                        <p className="text faq__text">You can simply breathe love into them or place them in moonlight. Trust your intuition.</p>
                    </details>

                    <details className="faq__details">
                        <summary className="faq__summary">Digital or physical?<span className="faq__arrow"></span></summary>

                        <p className="text faq__text">Both options are available. You can order the physical deck or start with a digital version instantly.</p>
                    </details>

                    <details className="faq__details">
                        <summary className="faq__summary">Are they really magical?<span className="faq__arrow"></span></summary>

                        <p className="text faq__text">Yes — if you believe in energy, resonance, and love — then this deck will become a sacred tool in your daily life.</p>
                    </details>
                </div>
            </section>

            <footer className="footer">
                <div className="footer__content">
                    <div className="footer__container">
                        <div className="footer__button-container">
                            <svg xmlns="http://www.w3.org/2000/svg" width="115" height="28" viewBox="0 0 115 28" fill="none">
                                <path d="M114.844 16.7603H101.084C101.057 16.9203 101.044 17.147 101.044 17.4403C101.044 19.227 101.284 20.787 101.764 22.1203C102.244 23.427 102.857 24.4137 103.604 25.0804C104.377 25.747 105.231 26.2137 106.164 26.4804C107.124 26.747 108.071 26.787 109.004 26.6003C109.964 26.4137 110.871 26.0803 111.724 25.6003C112.577 25.0937 113.284 24.467 113.844 23.7204L114.204 23.9604C114.151 24.067 114.057 24.2004 113.924 24.3604C113.817 24.4937 113.551 24.7737 113.124 25.2004C112.697 25.6004 112.217 25.9604 111.684 26.2803C111.177 26.5737 110.484 26.8404 109.604 27.0804C108.724 27.347 107.777 27.4804 106.764 27.4804C104.284 27.4804 102.257 26.627 100.684 24.9203C99.1374 23.2137 98.3641 21.0137 98.3641 18.3204C98.3641 15.7604 99.1774 13.627 100.804 11.9203C102.431 10.2137 104.591 9.36035 107.284 9.36035C107.844 9.36035 108.431 9.42702 109.044 9.56035C109.657 9.69368 110.311 9.93368 111.004 10.2803C111.724 10.6003 112.364 11.0137 112.924 11.5204C113.484 12.027 113.937 12.6937 114.284 13.5204C114.657 14.3204 114.844 15.227 114.844 16.2403V16.7603ZM106.724 9.84035C105.337 9.84035 104.111 10.4537 103.044 11.6804C101.977 12.907 101.337 14.427 101.124 16.2403H112.364C112.364 14.347 111.844 12.8137 110.804 11.6404C109.764 10.4403 108.404 9.84035 106.724 9.84035Z" fill="#E8E8E8"/>
                                <path d="M88.6712 27.4798C86.2979 27.4798 84.2979 26.6665 82.6712 25.0398C81.0446 23.4131 80.2312 21.3198 80.2312 18.7598C80.2312 16.1731 81.0846 13.9598 82.7913 12.1198C84.4979 10.2798 86.7646 9.35981 89.5912 9.35981C90.5779 9.35981 91.5246 9.51981 92.4313 9.83981C93.3379 10.1598 94.0046 10.4798 94.4313 10.7998L95.0713 11.2798V5.2798C95.0713 4.85314 94.9779 4.41314 94.7913 3.9598C94.6046 3.4798 94.4179 3.10647 94.2313 2.8398L93.9512 2.4798L97.4313 0.799805V24.2398C97.4313 24.6665 97.5246 25.1065 97.7113 25.5598C97.8979 26.0131 98.0846 26.3598 98.2712 26.5998L98.5513 26.9998H95.0713V24.1998C95.0179 24.2798 94.9513 24.3998 94.8713 24.5598C94.7913 24.6931 94.5646 24.9598 94.1913 25.3598C93.8446 25.7331 93.4446 26.0665 92.9912 26.3598C92.5646 26.6265 91.9646 26.8798 91.1913 27.1198C90.4179 27.3598 89.5779 27.4798 88.6712 27.4798ZM88.6312 9.9598C86.9512 10.0131 85.5779 10.7731 84.5113 12.2398C83.4446 13.7065 82.9112 15.6398 82.9112 18.0398C82.9112 20.1998 83.5779 22.1998 84.9112 24.0398C86.2712 25.8798 87.9113 26.7998 89.8313 26.7998C90.5513 26.7998 91.2179 26.6798 91.8313 26.4398C92.4713 26.1998 92.9779 25.9065 93.3512 25.5598C93.7246 25.2131 94.0446 24.8665 94.3112 24.5198C94.6046 24.1465 94.8046 23.8398 94.9112 23.5998L95.0713 23.2398V16.1598C95.0713 14.1598 94.4579 12.6131 93.2312 11.5198C92.0046 10.4265 90.4712 9.90647 88.6312 9.9598Z" fill="#E8E8E8"/>
                                <path d="M71.6797 27.4804C69.253 27.4804 67.173 26.6004 65.4397 24.8404C63.733 23.0537 62.8797 20.907 62.8797 18.4004C62.8797 15.8937 63.733 13.7604 65.4397 12.0004C67.173 10.2404 69.253 9.36035 71.6797 9.36035C74.133 9.36035 76.213 10.2404 77.9197 12.0004C79.653 13.7604 80.5197 15.8937 80.5197 18.4004C80.5197 20.907 79.653 23.0537 77.9197 24.8404C76.213 26.6004 74.133 27.4804 71.6797 27.4804ZM70.5997 10.0404C68.813 10.0404 67.4397 10.867 66.4797 12.5204C65.5464 14.147 65.2263 16.1337 65.5197 18.4804C65.813 20.827 66.653 22.8004 68.0397 24.4004C69.4264 26.0004 71.013 26.8004 72.7997 26.8004C74.5864 26.8004 75.9464 26.0004 76.8797 24.4004C77.8397 22.8004 78.173 20.827 77.8797 18.4804C77.5864 16.1337 76.733 14.147 75.3197 12.5204C73.933 10.867 72.3597 10.0404 70.5997 10.0404Z" fill="#E8E8E8"/>
                                <path d="M57.0616 27.4804C54.5282 27.4804 52.4349 26.667 50.7816 25.0404C49.1282 23.4137 48.3016 21.2004 48.3016 18.4004C48.3016 15.8937 49.2082 13.7604 51.0216 12.0004C52.8349 10.2404 55.0082 9.36035 57.5416 9.36035C58.4216 9.36035 59.2349 9.45368 59.9816 9.64035C60.7549 9.82702 61.3682 10.0537 61.8216 10.3204C62.2749 10.5604 62.6616 10.8137 62.9816 11.0803C63.3016 11.347 63.5282 11.5737 63.6616 11.7603L63.8616 12.0404H61.2616C61.1816 11.8804 61.0482 11.6937 60.8616 11.4804C60.7016 11.2404 60.2482 10.9337 59.5016 10.5603C58.7549 10.1603 57.8749 9.96035 56.8616 9.96035C55.0216 9.96035 53.5149 10.8537 52.3416 12.6404C51.1949 14.427 50.7416 16.4803 50.9816 18.8004C51.1949 21.0403 51.9816 22.9337 53.3416 24.4804C54.7016 26.027 56.3416 26.8004 58.2616 26.8004C59.1416 26.8004 60.0482 26.6137 60.9816 26.2404C61.9149 25.8404 62.6349 25.3337 63.1416 24.7204L63.5016 24.9604C61.9816 26.6404 59.8349 27.4804 57.0616 27.4804Z" fill="#E8E8E8"/>
                                <path d="M26.5647 14.2803C26.5647 13.8537 26.458 13.4137 26.2447 12.9604C26.058 12.507 25.8714 12.147 25.6847 11.8803L25.4047 11.5204L28.9247 9.84035V12.9604C29.4047 11.947 30.178 11.0937 31.2447 10.4003C32.338 9.70702 33.4847 9.36035 34.6847 9.36035C36.3647 9.36035 37.778 9.86702 38.9247 10.8803C40.0714 11.867 40.6447 13.4403 40.6447 15.6003V24.2403C40.6447 24.667 40.738 25.107 40.9247 25.5604C41.138 26.0137 41.338 26.3603 41.5247 26.6003L41.8047 27.0004H37.1247C37.898 26.0937 38.2847 25.1737 38.2847 24.2403V15.5603C38.2847 13.9603 37.7914 12.7204 36.8047 11.8404C35.8447 10.9337 34.778 10.4937 33.6047 10.5204C32.4314 10.5204 31.3514 10.9737 30.3647 11.8803C29.4047 12.7603 28.9247 13.987 28.9247 15.5603V24.2403C28.9247 24.667 29.018 25.107 29.2047 25.5604C29.3914 26.0137 29.5914 26.3603 29.8047 26.6003L30.0847 27.0004H25.4047C26.178 26.0937 26.5647 25.1737 26.5647 24.2403V14.2803Z" fill="#E8E8E8"/>
                                <path d="M23.5309 4.96008C23.2109 5.28008 22.8243 5.44008 22.3709 5.44008C21.9176 5.44008 21.5176 5.28008 21.1709 4.96008C20.8509 4.61341 20.6909 4.21341 20.6909 3.76008C20.6909 3.30674 20.8509 2.92008 21.1709 2.60008C21.5176 2.25341 21.9176 2.08008 22.3709 2.08008C22.8243 2.08008 23.2109 2.25341 23.5309 2.60008C23.8776 2.92008 24.0509 3.30674 24.0509 3.76008C24.0509 4.21341 23.8776 4.61341 23.5309 4.96008ZM21.3309 13.6001C21.3309 13.1734 21.2376 12.7867 21.0509 12.4401C20.8643 12.0934 20.6643 11.8534 20.4509 11.7201L20.1709 11.5201L23.6909 9.84008V24.2401C23.6909 24.6667 23.7843 25.1067 23.9709 25.5601C24.1843 26.0134 24.3843 26.3601 24.5709 26.6001L24.8509 27.0001H20.1709C20.9443 26.0934 21.3309 25.1734 21.3309 24.2401V13.6001Z" fill="#E8E8E8"/>
                                <path d="M20.64 26.9998H15.64C15.9333 26.4932 15.4667 25.5732 14.24 24.2398L9.6 19.0798L5.04 24.2398C4.50666 24.8265 4.18666 25.3598 4.08 25.8398C4 26.2932 4.05333 26.5998 4.24 26.7598L4.52 26.9998H1.36C2.10666 26.4932 3.09333 25.5732 4.32 24.2398L9.24 18.6798L3.76 12.5998C3.14666 11.9065 2.57333 11.3332 2.04 10.8798C1.50666 10.4265 1.12 10.1465 0.879998 10.0398L0.559998 9.83984H5.52C5.25333 10.3465 5.72 11.2665 6.92 12.5998L10.92 17.0398L14.76 12.5998C15.2933 11.9865 15.6 11.4532 15.68 10.9998C15.7867 10.5465 15.7467 10.2398 15.56 10.0798L15.28 9.83984H18.4C17.6533 10.2932 16.68 11.2132 15.48 12.5998L11.28 17.4398L17.4 24.2398C18.0133 24.9332 18.5867 25.5065 19.12 25.9598C19.68 26.4132 20.08 26.7065 20.32 26.8398L20.64 26.9998Z" fill="#E8E8E8"/>
                            </svg>

                            <button className="header__button footer__button" onClick={scrollToConnect}>Get the Deck</button>
                        </div>

                        <div className="footer__links-content">
                            <div className="footer__links-container">
                                <a className="text footer__link" onClick={scrollToRituals}>Rituals</a>
                                <a className="text footer__link" onClick={scrollToCards}>Cards</a>
                                <a className="text footer__link" onClick={scrollToReviews}>Reviews</a>
                                <a className="text footer__link" onClick={scrollToHowItWorks}>How it Works</a>
                                <a className="text footer__link" onClick={scrollToAuthor}>Author</a>
                                <a className="text footer__link" onClick={scrollToFaq}>FAQ</a>
                            </div>

                            <div className="footer__social-content">
                                <div className="footer__links-container">
                                    <a className="text footer__link">Privacy Policy</a>
                                    <a className="text footer__link">Terms & Conditions</a>
                                </div>

                                <div className="footer__social-container">
                                    {/* <a href="#">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M20.71 3.65451C20.71 3.65451 22.6525 2.89701 22.49 4.73651C22.4365 5.49401 21.951 8.14551 21.573 11.013L20.278 19.508C20.278 19.508 20.17 20.7525 19.1985 20.969C18.2275 21.185 16.7705 20.2115 16.5005 19.995C16.2845 19.8325 12.4535 17.3975 11.1045 16.2075C10.7265 15.8825 10.2945 15.2335 11.1585 14.476L16.8245 9.06501C17.472 8.41501 18.1195 6.90001 15.4215 8.74001L7.86653 13.88C7.86653 13.88 7.00303 14.4215 5.38453 13.9345L1.87653 12.852C1.87653 12.852 0.581525 12.0405 2.79402 11.229C8.19053 8.68601 14.828 6.08901 20.7095 3.65401" fill="white"/>
                                        </svg>
                                    </a> */}

                                    <a href="https://www.instagram.com/leanca_happy" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M13.028 2C14.153 2.003 14.724 2.009 15.217 2.023L15.411 2.03C15.635 2.038 15.856 2.048 16.123 2.06C17.187 2.11 17.913 2.278 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8307 4.17773 21.2241 4.78247 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.952 8.144 21.962 8.365 21.97 8.59L21.976 8.784C21.991 9.276 21.997 9.847 21.999 10.972L22 11.718V13.028C22.0024 13.7574 21.9947 14.4868 21.977 15.216L21.971 15.41C21.963 15.635 21.953 15.856 21.941 16.122C21.891 17.187 21.721 17.912 21.475 18.55C21.2241 19.2175 20.8307 19.8223 20.322 20.322C19.8222 20.8307 19.2175 21.2242 18.55 21.475C17.913 21.722 17.187 21.89 16.123 21.94L15.411 21.97L15.217 21.976C14.724 21.99 14.153 21.997 13.028 21.999L12.282 22H10.973C10.2432 22.0026 9.51348 21.9949 8.78396 21.977L8.58996 21.971C8.35257 21.962 8.11523 21.9517 7.87796 21.94C6.81396 21.89 6.08796 21.722 5.44996 21.475C4.78279 21.2241 4.1784 20.8306 3.67896 20.322C3.1699 19.8224 2.77607 19.2176 2.52496 18.55C2.27796 17.913 2.10996 17.187 2.05996 16.122L2.02996 15.41L2.02496 15.216C2.00652 14.4868 1.99819 13.7574 1.99996 13.028V10.972C1.99719 10.2426 2.00452 9.5132 2.02196 8.784L2.02896 8.59C2.03696 8.365 2.04696 8.144 2.05896 7.878C2.10896 6.813 2.27696 6.088 2.52396 5.45C2.77565 4.7822 3.17018 4.17744 3.67996 3.678C4.17911 3.16955 4.78315 2.77607 5.44996 2.525C6.08796 2.278 6.81296 2.11 7.87796 2.06C8.14396 2.048 8.36596 2.038 8.58996 2.03L8.78396 2.024C9.51315 2.00623 10.2426 1.99857 10.972 2.001L13.028 2ZM12 7C10.6739 7 9.40211 7.52678 8.46442 8.46447C7.52674 9.40215 6.99996 10.6739 6.99996 12C6.99996 13.3261 7.52674 14.5979 8.46442 15.5355C9.40211 16.4732 10.6739 17 12 17C13.326 17 14.5978 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5978 7.52678 13.326 7 12 7ZM12 9C12.3939 8.99993 12.784 9.07747 13.148 9.22817C13.512 9.37887 13.8428 9.5998 14.1214 9.87833C14.4 10.1569 14.6211 10.4875 14.7719 10.8515C14.9227 11.2154 15.0004 11.6055 15.0005 11.9995C15.0005 12.3935 14.923 12.7836 14.7723 13.1476C14.6216 13.5116 14.4007 13.8423 14.1221 14.121C13.8436 14.3996 13.5129 14.6206 13.149 14.7714C12.785 14.9223 12.3949 14.9999 12.001 15C11.2053 15 10.4422 14.6839 9.87964 14.1213C9.31703 13.5587 9.00096 12.7956 9.00096 12C9.00096 11.2044 9.31703 10.4413 9.87964 9.87868C10.4422 9.31607 11.2053 9 12.001 9M17.251 5.5C16.9194 5.5 16.6015 5.6317 16.3671 5.86612C16.1327 6.10054 16.001 6.41848 16.001 6.75C16.001 7.08152 16.1327 7.39946 16.3671 7.63388C16.6015 7.8683 16.9194 8 17.251 8C17.5825 8 17.9004 7.8683 18.1348 7.63388C18.3693 7.39946 18.501 7.08152 18.501 6.75C18.501 6.41848 18.3693 6.10054 18.1348 5.86612C17.9004 5.6317 17.5825 5.5 17.251 5.5Z" fill="white"/>
                                        </svg>
                                    </a>

                                    {/* <a href="#">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M10 15L15.19 12L10 9V15ZM21.56 7.17C21.69 7.64 21.78 8.27 21.84 9.07C21.91 9.87 21.94 10.56 21.94 11.16L22 12C22 14.19 21.84 15.8 21.56 16.83C21.31 17.73 20.73 18.31 19.83 18.56C19.36 18.69 18.5 18.78 17.18 18.84C15.88 18.91 14.69 18.94 13.59 18.94L12 19C7.81 19 5.2 18.84 4.17 18.56C3.27 18.31 2.69 17.73 2.44 16.83C2.31 16.36 2.22 15.73 2.16 14.93C2.09 14.13 2.06 13.44 2.06 12.84L2 12C2 9.81 2.16 8.2 2.44 7.17C2.69 6.27 3.27 5.69 4.17 5.44C4.64 5.31 5.5 5.22 6.82 5.16C8.12 5.09 9.31 5.06 10.41 5.06L12 5C16.19 5 18.8 5.16 19.83 5.44C20.73 5.69 21.31 6.27 21.56 7.17Z" fill="white"/>
                                        </svg>
                                    </a> */}

                                    {/* <a href="#">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M9.04 21.54C10 21.83 10.97 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 16.25 4.67 19.9 8.44 21.34C8.35 20.56 8.26 19.27 8.44 18.38L9.59 13.44C9.59 13.44 9.3 12.86 9.3 11.94C9.3 10.56 10.16 9.53 11.14 9.53C12 9.53 12.4 10.16 12.4 10.97C12.4 11.83 11.83 13.06 11.54 14.24C11.37 15.22 12.06 16.08 13.06 16.08C14.84 16.08 16.22 14.18 16.22 11.5C16.22 9.1 14.5 7.46 12.03 7.46C9.21 7.46 7.55 9.56 7.55 11.77C7.55 12.63 7.83 13.5 8.29 14.07C8.38 14.13 8.38 14.21 8.35 14.36L8.06 15.45C8.06 15.62 7.95 15.68 7.78 15.56C6.5 15 5.76 13.18 5.76 11.71C5.76 8.55 8 5.68 12.32 5.68C15.76 5.68 18.44 8.15 18.44 11.43C18.44 14.87 16.31 17.63 13.26 17.63C12.29 17.63 11.34 17.11 11 16.5L10.33 18.87C10.1 19.73 9.47 20.88 9.04 21.57V21.54Z" fill="white"/>
                                        </svg>
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <p className="text footer__copyright">© 2025, Xin Code by Natalia Leanca</p>
                </div>
            </footer>

            <div className={`popup ${isPopupVisible ? 'popup_type_visible' : ''}`}>
                <div className="popup__content">
                    <iframe className="popup__video" src={`${isPopupVisible ? video : ''}`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" title="showreel"></iframe>
                    <button className="popup__close" onClick={() => togglePopupVisible()}></button>
                </div>
            </div>
        </>
    );
}
